import { Card, Chip, CrudMode, Grid, Stack, useElementBreakpoints } from "@compass/core";
import { Select, StudentCustomIdsPaster } from "components";
import { Student, StudentGroupEditResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const SelectedStudents = (props: {
  students: Student[];
  setStudents: (value: Student[]) => void;
  editResource: StudentGroupEditResource | undefined;
  crudMode: CrudMode;
  setEditMode: () => void;
}) => {
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
  const [students, setStudents] = useState<Map<number, Student>>(new Map());
  const [addingStudent, setAddingStudent] = useState<Student>();

  useEffect(() => {
    setStudents(new Map(props.students.map((x) => [x.id, x])));
  }, [props.students]);

  const updateStudents = (map: Map<number, Student>) => {
    setStudents(map);
    props.setStudents(Array.from(map.values()));
  };

  useEffect(() => {
    if (addingStudent) {
      props.setEditMode();
      updateStudents(new Map(students.set(addingStudent.id, addingStudent)));
      setAddingStudent(undefined);
    }
  }, [addingStudent]);

  const addStudents = (customIdTypeId: number | undefined, customIds: string[]) => {
    if (customIdTypeId && customIds && customIds.length > 0) {
      ApiService.students.getByCustomIds({ customIdTypeId: customIdTypeId, customIds: customIds }).then((response) => {
        let updatedStudents = new Map(students);
        response.forEach((student) => updatedStudents.set(student.id, student));
        updateStudents(updatedStudents);
      });
    }
  };

  return (
    <Card header="Students">
      <Stack ref={breakpointsRef} spacing="lg">
        {props.crudMode === "edit" && (
          <Grid container spacing="md">
            <Grid item xs={largeFieldBreakpoints}>
              <Select
                label="Add student"
                value={addingStudent}
                getOptionLabel={(option) => `${option.lastName}, ${option.firstName} (${option.customId1})`}
                onChange={(e, value) => setAddingStudent(value)}
                fetchFunction={(searchString: string) => ApiService.search.students(searchString)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionDisabled={(option) => students?.has(option.id)}
              />
            </Grid>

            <Grid item xs={largeFieldBreakpoints}>
              <StudentCustomIdsPaster onAdd={(customIdTypeId, customIds) => addStudents(customIdTypeId, customIds)} />
            </Grid>
          </Grid>
        )}

        <Grid container spacing="xs">
          {Array.from(students.values()).map((student) => (
            <Grid item>
              <Chip
                label={`${student.lastName}, ${student.firstName} (${student.customId1})`}
                onDelete={
                  props.crudMode === "edit"
                    ? () => {
                        props.setEditMode();
                        const updatedStudents = new Map(students);
                        updatedStudents.delete(student.id);
                        updateStudents(updatedStudents);
                      }
                    : undefined
                }
              />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Card>
  );
};
